const $ = require('cash-dom');

const QuickNav = {
  init() {
    this._initQuickNav();
    this._initQuickNavMobile();
  },

  _initQuickNav: function () {
    var self = this;

    var $quickNavs = $('.quick_nav');
    if (!$quickNavs.length) {
      return;
    }

    $quickNavs.each(function () {
      let $quickNav = $(this);
      window.addEventListener('scroll', function (e) {
        $quickNav.find('li > a').each(function () {
          const $currentA = $(this);

          var id = $currentA.attr('href');
          var $section = $(id);

          if ($section.length > 0) {
            var top = $section.get(0).getBoundingClientRect().top;

            if (top > -10 && top < 200) {

              $quickNav.find('li').removeClass('active');
              $currentA.parent('li').addClass('active');

              self._recalculateQuickNavScroll($quickNav);

              return false;
            }
          }
        });
      }, {passive: true});

      // TODO check this
      // window.scroll({top: 0, left: 0, behavior: 'smooth'});
    });
  },

  _recalculateQuickNavScroll: function ($quickNav) {
    //scroll list to active paragraph
    let listHolder = $quickNav.find('.quick-nav-list-holder');

    if (typeof listHolder !== 'undefined' && listHolder.length) {
      let activePosition = listHolder.find('.active').position();

      if (typeof activePosition !== 'undefined') {
        let highestPos = listHolder.get(0).scrollTop,
          lowerPos = highestPos + Math.round(listHolder.height());

        if (activePosition.top < highestPos || activePosition.top > lowerPos) {
          listHolder.get(0).scrollTo({top: Math.round(activePosition.top), left: 0, behavior: 'smooth'});
        }
      }
    }
  },

  _initQuickNavMobile() {
    const $quickNavMobile = $('#quick_nav_mobile');

    if (!$quickNavMobile.length) {
      return;
    }

    let isOpen = false;
    const $quickNavTitle = $quickNavMobile.find('.quick-nav-title');
    const $quickNavListHolder = $quickNavMobile.find('.quick-nav-list-holder');
    const $icon = $quickNavTitle.find('i');

    $quickNavMobile.find('.quick-nav-title').on('click', function () {
      $(this).toggleClass('active');
      $quickNavListHolder.toggle();

      if (isOpen) {
        $icon.removeClass('fa-caret-up').addClass('fa-caret-down');
      } else {
        $icon.removeClass('fa-caret-down').addClass('fa-caret-up');
      }

      isOpen = !isOpen;
    });
  },
};

module.exports = QuickNav;
